<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Giften aan een ANBI
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Giften aan een ANBI (Algemeen Nut Beogende Instelling) zijn aftrekbaar. Meestal maakt een instelling
                (bijvoorbeeld een goed doel) zelf bekend dat het een ANBI-status heeft.
                <div class="space10"></div>

                In de volgende situaties zijn betalingen aan een ANBI niet aftrekbaar. Het gaat om betalingen:
                <li class="list">die wettelijk verplicht zijn zoals belastingen en heffingen</li>
                <li class="list">waar iets tegenover staat zoals huur- en energiekosten of zorgverzekeringspremies</li>
                <li class="list">voor een lot van een goed doel zoals de Postcodeloterij of voor kinderpostzegels.</li>

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Voorwaarden aftrek gewone giften
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Gewone giften mag je aftrekken onder de volgende voorwaarden:

                <li class="list">je doet giften aan een instelling die bij de Belastingdienst is geregistreerd als:<br/>
                    - een Algemeen Nut Beogende Instelling (ANBI)<br/>
                    - een steunstichting voor een Sociaal Belang Behartigende Instelling (SBBI)
                </li>
                <li class="list">je kunt je giften aantonen, bijvoorbeeld met bankafschriften of kwitanties.</li>
                <li class="list">Er staat geen tegenprestatie tegenover.</li>
                Let op! Een betaling in contant geld telt niet mee als gift.
                <div class="space10"></div>

                <b>Giften in natura</b><br/>
                Giften in natura mag je ook aftrekken, onder dezelfde voorwaarden. Een gift in natura is een gift in een
                andere vorm dan geld, zoals een verzameling munten, een kunstvoorwerp of aandelen in een bv.
                <div class="space10"></div>

                <b>Vrijwilligerswerk</b><br/>
                Doet je vrijwilligerswerk voor een instelling die bij de Belastingdienst is geregistreerd als een ANBI?
                En ziet je af van een vergoeding die je hiervoor kunt krijgen? Dan mag je onder voorwaarden het bedrag
                van de vrijwilligersvergoeding aftrekken.<br/>
                Het kan ook gaan om kosten die je maakt om het vrijwilligerswerk te doen.
                <div class="space10"></div>

                <b>Loterij</b>
                Heb je loten gekocht voor een (goede doelen)loterij? Deze mag je niet aftrekken.
                <div class="space10"></div>

                <b>Extra aftrek voor giften aan culturele ANBI's</b><br/>
                Doe je in {{ this.year }} een gewone of periodieke gift aan een instelling die bij de Belastingdienst is
                geregistreerd als culturele ANBI? Dan wordt je aftrek verhoogd met 25%. Je hoeft dit niet zelf uit te
                rekenen; het programma berekent dit voor je. De extra aftrek voor giften aan culturele ANBI's is
                maximaal € 1.250 en geldt voor periodieke en gewone giften aan culturele ANBI's samen.
                <div class="space10"></div>

                <b>Drempel</b><br/>
                Voor gewone giften geldt een drempel en een maximaal aftrekbaar bedrag. De drempel is 1% van je
                drempelinkomen, maar minimaal € 60. Heb je een fiscale partner, dan is de drempel 1% van je
                gezamenlijke drempelinkomen. Wat je meer betaalt dan dit drempelbedrag, mag je aftrekken.
                <div class="space10"></div>

                <b>Maximumbedrag</b><br/>
                Je mag niet meer aftrekken dan het maximum: 10% van je drempelinkomen. Heb je een fiscale partner, dan
                is
                de drempel 10% van je gezamenlijke drempelinkomen. Heb je recht op de extra aftrek voor giften aan
                culturele ANBI's? Dan wordt het maximaal aftrekbare bedrag voor gewone giften verhoogd met het bedrag
                van de extra aftrek. Voor periodieke giften geldt geen drempel en geen maximaal aftrekbaar bedrag.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Voorwaarden aftrek periodieke giften
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Periodieke giften mag je aftrekken onder de volgende voorwaarden:
                <li class="list">je maakt regelmatig (minimaal 1 keer per jaar) bedragen over naar:<br/>
                    een instelling die bij de Belastingdienst is geregistreerd als een Algemeen Nut Beogende Instelling
                    (ANBI)<br/>
                    een vereniging (geen ANBI) die voldoet aan de aanvullende voorwaarden
                </li>
                <li class="list">de bedragen zijn steeds even hoog.</li>
                <li class="list">je hebt de gift laten vastleggen bij een notaris of in een onderhandse akte van
                    schenking.
                </li>
                <li class="list">je doet deze gift minimaal 5 jaar achter elkaar. Bij overlijden geldt deze termijn
                    niet.
                </li>
                <li class="list">er staat geen tegenprestatie tegenover.</li>
                Voor de aftrek van periodieke giften geldt geen drempel en geen maximaal aftrekbaar bedrag.
                <div class="space10"></div>

                <b>maandelijkse afschrijving of automatische incasso</b><br/>
                Een maandelijkse afschrijving of automatische incasso op zich is geen periodieke gift. Je moet hebben
                laten vastleggen in een notariële akte of overeenkomst hoeveel je geeft en hoe lang je de gift geeft.
                <div class="space10"></div>

                <b>Loterij</b><br/>
                Heb je loten gekocht voor een (goede doelen)loterij? Deze mag je niet aftrekken.
                <div class="space10"></div>

                <b>Extra aftrek voor giften aan culturele ANBI's</b>
                Doe je in {{ this.year }} een gewone of periodieke gift aan een instelling die bij de Belastingdienst is
                geregistreerd als culturele ANBI? Dan wordt je aftrek verhoogd met 25%. De extra aftrek voor giften aan
                culturele ANBI's is maximaal € 1.250 en geldt voor periodieke en gewone giften aan culturele ANBI's
                samen.
                <div class="space10"></div>

                <b>Giften in natura</b><br/>
                Je kunt ook een periodieke gift in natura afspreken. Een gift in natura is een gift in een andere vorm
                dan geld, zoals een verzameling munten, een kunstvoorwerp of aandelen in een bv.
                <div class="space10"></div>

                Bij een periodieke gift in natura verplicht je je om jaarlijks een verstrekking te doen. Als je jezelf
                bijvoorbeeld verplicht om jaarlijks een voedselpakket ter waarde van € 60 te verstrekken, doe je een
                periodieke gift in natura.
                <div class="space10"></div>

                <b>Vaststelling omvang of waarde gift in natura</b>
                Als je de overeenkomst aangaat, moet de omvang of waarde van de periodieke verstrekking worden
                vastgesteld en voor iedereen duidelijk zijn. Deze omvang of waarde moet elk jaar hetzelfde zijn.
                <div class="space10"></div>

                <u>Voorbeeld jaarlijks dezelfde omvang</u><br/>
                Je schenkt elk jaar speelgoed aan een instelling die sinterklaascadeautjes verzorgt voor weeskinderen.
                Je spreekt af dat je 8 jaar lang elk jaar 5 poppen, 5 knuffelbeesten en 5 kinderboeken verstrekt. De
                omvang van de jaarlijkse verstrekkingen is elk jaar hetzelfde, maar de waarde kan elk jaar anders zijn.
                Omdat de omvang van de jaarlijkse verstrekking vaststaat, kun je jaarlijks de werkelijke kosten van de
                verstrekking aftrekken in de aangifte inkomstenbelasting. Dat kan € 250 zijn in {{ this.year }}, en
                in {{ this.year + 1 }} kan dat € 300 zijn.
                <div class="space10"></div>

                <b>Aftrek beperkt</b><br/>
                Let op! M.i.v. 4 oktober 2022 is de aftrek van periodieke giften beperkt tot € 250.000 voor jou en je
                eventuele fiscale partner. Dit maximum geldt niet voor verplichtingen aangegaan vóór 4 oktober 2022.
                <div class="space10"></div>

                <b>Transactienummer</b><br/>
                Vul hier het transactienummer in van de gift. Dat staat op de schriftelijke overeenkomst die je hebt
                afgesloten met de instelling of vereniging waaraan je deze gift hebt gedaan. Heb je geen
                transactienummer? Vul dan een '1' in.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                Periodieke giften een een vereniging of steunstichting SBBI
            </button>
        </h2>
        <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Een gift aan een vereniging</b><br/>
                Doe je een periodieke gift aan een vereniging die geen ANBI is? Dan mag je deze gift aftrekken als de
                vereniging voldoet aan alle volgende voorwaarden:<br/>

                <ul>
                    <li>De vereniging heeft minstens 25 leden.</li>
                    <li>De vereniging heeft volledige rechtsbevoegdheid.</li>
                    <li>De vereniging is vrijgesteld van vennootschapsbelasting of er niet aan onderworpen.</li>
                    <li>De vereniging is gevestigd in een EU-land, op St. Maarten, Curaçao, Aruba, de BES-eilanden of in
                        een
                        ander door ons aangewezen land.
                    </li>
                </ul>
                <div class="space10"></div>

                <b>Een gift aan een steunstichting SBBI</b><br/>
                Een steunstichting SBBI is een speciale stichting die is opgericht om geld in te zamelen voor een
                jubileum van een SBBI (Sociaal Belang Behartigende Instelling) op het gebied van sport en muziek. Een
                SBBI is bijvoorbeeld een sportclub, zangkoor, dansgroep of een muziek- of harmonievereniging.
                <div class="space10"></div>
                De steunstichting kan voor dat jubileum maximaal 1 kalenderjaar lang door ons worden aangemerkt als een
                steunstichting SBBI. Alleen in dat jaar mag je giften aan deze stichting aftrekken.
                <div class="space10"></div>
                Wil je weten of een instelling is aangemerkt als steunstichting SBBI? Kijk dan in het <a target="_blank"
                                                                                                         href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/zakelijk/bijzondere_regelingen/goede_doelen/steunstichtingen_sbbi/overzicht_steunstichtingen_sbbi">overzicht
                steunstichtingen SBBI</a>.


            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Aftrek giften als vrijwilliger
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Doe je vrijwilligerswerk voor een instelling die bij de Belastingdienst is geregistreerd als een
                Algemeen Nut Beogende Instelling (ANBI)? Onder voorwaarden mag je een bedrag aftrekken als gewone gift.
                De volgende situaties
                zijn mogelijk:
                <li class="list">je kunt een vrijwilligersvergoeding krijgen, maar je ziet hiervan af.</li>
                <li class="list">je maakt kosten en krijgt hiervoor geen vergoeding.</li>
                <li class="list">je ziet af van de vrijwilligersvergoeding en je krijgt ook geen kostenvergoeding bij
                    dezelfde ANBI.
                </li>
                <div class="space10"></div>

                <b>Afzien van de vrijwilligersvergoeding</b><br/>
                Kun je voor je inzet voor een instelling een vrijwilligersvergoeding krijgen? Maar ziet je hiervan af?
                Dan mag je het bedrag van deze vergoeding aftrekken als een gewone gift. Je moet dan wel kunnen aantonen
                dat je en de instelling aan de volgende voorwaarden voldoen:
                <li class="list">de BelastingdienstW heeft de instelling aangewezen als ANBI.</li>
                <li class="list">de ANBI heeft een regeling getroffen waardoor je in aanmerking komt voor een
                    vergoeding.
                </li>
                <li class="list">de financiële situatie van de ANBI is zo dat zij de vergoeding ook kan uitbetalen.</li>
                <li class="list">de ANBI heeft de bedoeling om de vergoeding daadwerkelijk uit te betalen.</li>
                <li class="list">je kunt zelf bepalen dat je de vergoeding niet wilt ontvangen, maar aan de ANBI
                    schenkt.
                </li>
                <div class="space10"></div>

                <b>Wel kosten, geen vergoeding</b><br/>
                Maak je kosten voor een ANBI, bijvoorbeeld als vrijwilliger? En ontvang je geen vergoeding voor die
                kosten? Dan tellen deze kosten mee als een gewone gift. Als de ANBI de gemaakte kosten niet kan
                vergoeden, is ook sprake van een gift.
                <div class="space10"></div>

                Voor autokosten die je niet declareert, mag je een vast bedrag van € 0,21 per kilometer meetellen. Voor
                taxikosten mag je de werkelijke kosten meetellen.
                <div class="space10"></div>

                <b>Afzien van de vrijwilligersvergoeding en ook geen kostenvergoeding bij dezelfde ANBI</b><br/>
                Zie je voor een ANBI af van een vrijwilligersvergoeding én maak je kosten waarvoor je geen vergoeding
                krijgt? Dan mag je het bedrag van deze vrijwilligersvergoeding én het bedrag van deze kosten aftrekken
                als gewone gift als je voldoet aan de voorwaarden die hierboven zijn genoemd. Om het aftrekbare bedrag
                van de kosten te berekenen, moet je eerst het bedrag van de kosten waarvoor je geen vergoeding krijgt
                verminderen met het bedrag waarvoor je geen vrijwilligersvergoeding krijgt.
                <div class="space10"></div>

                <u>Voorbeeld</u><br/>
                Je maakt voor een ANBI bijvoorbeeld € 750 kosten. Je ziet ook af van een vrijwilligersvergoeding van €
                600 van deze ANBI. Het bedrag van de aftrekbare gift is € 600 + € 150 (€ 750 -/- € 600) = € 750.


            </div>
        </div>
    </div>

</div>


